import type { TenantBranding } from "../types";

// E1 — branded sign-in landing. Rendered when /api/me returns 401 and the
// SPA has resolved a tenant from Host/?tenant. The Sign-in-with-Google
// button hits the existing FastAPI /auth/google/login route which sets
// the session cookie and redirects back to /reports/.
export function VentureSignIn({ branding }: { branding: TenantBranding }) {
  const onSignIn = () => {
    window.location.href = "/auth/google/login?next=/reports/";
  };
  return (
    <div className="signin-shell">
      <div className="signin-card">
        {branding.logo_url ? (
          <img src={branding.logo_url} alt="" className="signin-logo" />
        ) : (
          <div
            className="signin-logo-glyph"
            style={{ background: branding.primary_color }}
          />
        )}
        <div className="signin-eyebrow">{branding.display_name}</div>
        <h1 className="signin-title">{branding.application_name}</h1>
        <p className="signin-sub">
          Sign in with your Google account to access your reports.
        </p>
        <button
          className="signin-btn"
          onClick={onSignIn}
          style={{ background: branding.primary_color }}
        >
          <span className="signin-g">G</span>
          Sign in with Google
        </button>
        {branding.domain && (
          <div className="signin-foot">{branding.domain}</div>
        )}
      </div>
    </div>
  );
}
